import { SpanStatusCode, trace } from "@opentelemetry/api";
import { flatten } from "flat";

import { createLogger } from "@/logger";

const log = createLogger("telemetry");

import { flushHoneycomb } from "@/init/honeycomb";

const TRACER_NAME = "web-db-reset";

export type TelemetryAttrs = Record<string, unknown>;

export function recordEvent(name: string, attributes?: TelemetryAttrs): void {
  try {
    log.debug(`[recordEvent] Telemetry event`, { name, attributes });
    const tracer = trace.getTracer(TRACER_NAME);
    tracer.startActiveSpan(name, (span) => {
      if (attributes) span.setAttributes(flatten(attributes));
      span.setStatus({ code: SpanStatusCode.OK });
      span.end();
    });
  } catch (error) {
    log.error(`[recordEvent] Error recording event`, { name, attributes, error });
  }
}

export async function recordEventAndFlush(name: string, attributes?: TelemetryAttrs): Promise<void> {
  recordEvent(name, attributes);
  await flushHoneycomb();
}
